import { BaseDevice, CustomLayout } from '../../base_device'
import { DevicePid, EffectIndex, KK } from '@/define/define'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import list_icon from '@/assets/img/device/fe75/list_icon.png'
import { fe75VKCodes } from '../keycode/vkeycode'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_IROKN_ST_V1 } from '../../light/light_effect_list'

export class FE75PRO extends BaseDevice {
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_IROKN_ST_V1
  square = getDeviceKeySquare(DevicePid.IROKFe75Pro)
  name: string = 'FE75_PRO'
  icon: string = list_icon
  width: number = 658

  protected y_number: number = 12
  customLayout: CustomLayout = {
    0xc: this.createSquare(41, 2),
    0x24: this.createSquare(20.1, 2),
    0x3c: this.createSquare(21, 2),
    0x5a: this.createSquare(12, 2),
    0x1: this.createSquare(2, this.y_number),
    0x7: this.createSquare(2, this.y_number),
    0xd: this.createSquare(2, this.y_number),
    0x13: this.createSquare(2, this.y_number),
    0x19: this.createSquare(2, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x25: this.createSquare(2, this.y_number),
    0x2b: this.createSquare(2, this.y_number),
    0x31: this.createSquare(2, this.y_number),
    0x37: this.createSquare(2, this.y_number),
    0x3d: this.createSquare(2, this.y_number),
    0x43: this.createSquare(2, this.y_number),
    0x49: this.createSquare(2, this.y_number),
    0x4f: this.createSquare(2, this.y_number, 74),
    0x5b: this.createSquare(12, this.y_number),
    0x2: this.createSquare(2, 2, 54.8),
    0x50: this.createSquare(2, 2, 56),
    0x5c: this.createSquare(12, 2),
    0x3: this.createSquare(2, 2, 67.5),
    0x51: this.createSquare(2, 2, 81.5),
    0x5d: this.createSquare(12, 2),
    0x4: this.createSquare(2, 2, 87.6),
    0x52: this.createSquare(2, 2, 62),
    0x58: this.createSquare(42, 2),
    0x5: this.createSquare(2, 2, 47.5),
    0xb: this.createSquare(2, 2, 47.5),
    0x11: this.createSquare(2, 2, 47.5),
    0x23: this.createSquare(2, 2, 222.5),
    0x35: this.createSquare(2, 2, 47.5),
    0x53: this.createSquare(4, 2),
  }
  inoperableKeys: KK[] = [0x3b]
  vkcodes = fe75VKCodes
  absoluteKey: CustomLayout = {
    0x58: this.createSquare(566, 4), // up
    0x53: this.createSquare(527, 4), // left
    0x59: this.createSquare(566, 4), // down
    0x5f: this.createSquare(605, 4), // right
  }
}
